/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRef} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {StepperComponent} from '../../../assets/ts/components'
import {ProjectModalHeader} from './ProjectModalHeader'
import {ProjectModalContent} from './ProjectModalContent'

type Props = {
  show: boolean
  handleClose: () => void
  trelloBoard?: any // Dados do board Trello selecionado (opcional)
  trelloMapping?: any // Dados do mapeamento das listas Trello (opcional)
  clickUpList?: any // Dados da lista ClickUp selecionada (opcional)
  clickUpMapping?: any // Dados do mapeamento das tasks ClickUp (opcional)
  projectTemplate?: any // Dados do template de projeto (opcional)
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ProjectCreateModalStepper = ({show, handleClose, trelloBoard, trelloMapping, clickUpList, clickUpMapping, projectTemplate}: Props) => {
  return createPortal(
    <Modal
      id='kt_modal_edit_project'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      data-backdrop='static'
      enforceFocus={false}
    >
      <ProjectModalHeader handleClose={handleClose} />
      <ProjectModalContent 
        handleClose={handleClose} 
        redirectAfterCreate={true}
        trelloBoard={trelloBoard}
        trelloMapping={trelloMapping}
        clickUpList={clickUpList}
        clickUpMapping={clickUpMapping}
        projectTemplate={projectTemplate}
      />
    </Modal>,
    modalsRoot
  )
}

export {ProjectCreateModalStepper}
